import { ALLOWED_FILE_TYPES } from 'AgentApp/ts/constants/agent-file.constants';

/**
 * True only when the drag payload carries files (not selected text or an internal element drag), so
 * drop zones don't hijack unrelated drags.
 */
export const isFileDragEvent = (event: DragEvent): boolean =>
    Array.from(event.dataTransfer?.types ?? []).includes('Files');

export const isAllowedFileType = (file: File): boolean => {
    const name = file.name.toLowerCase();
    const mimeType = file.type.toLowerCase();
    return ALLOWED_FILE_TYPES.some((allowed) => {
        if (allowed.endsWith('/*')) {
            const prefix = allowed.slice(0, -1); // e.g. "image/"
            return mimeType.startsWith(prefix);
        }
        if (allowed.startsWith('.')) {
            return name.endsWith(allowed.toLowerCase());
        }
        return mimeType === allowed.toLowerCase();
    });
};

/**
 * Sprite icon for an attachment
 */
export const getFileIcon = (fileName: string, mimeType: string = ''): string => {
    const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
    if (mimeType.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension)) {
        return 'icon-picture';
    }
    if (
        mimeType === 'text/csv' ||
        mimeType.includes('spreadsheet') ||
        mimeType.includes('excel') ||
        ['csv', 'xlsx', 'xls'].includes(extension)
    ) {
        return 'icon-table';
    }
    return 'icon-overview';
};
